/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'login': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M573.2 646.5H309.8c-12.6 0-20.8-5.8-22.9-16.1-.4-2.1-.4-4.2-.4-6.4V397.2c0-14.3 7.8-22 22.3-22h264.3V166.5c0-9.3 4.4-16.6 11.9-19.5 8.6-3.3 16.2-1.8 22.7 5.1 3.7 3.9 7.8 7.5 11.6 11.4 48.2 48.1 96.3 96.2 144.5 144.2 61.9 61.7 123.7 123.4 185.6 185.2 10.3 10.3 10.4 21.1.2 31.2-88.5 88.4-177 176.8-265.6 265.1-25.2 25.1-50.5 50.1-75.7 75.2-6.5 6.5-13.7 9.3-22.5 6-8.6-3.3-12.6-10-12.6-20.7V646.5zm-159-497.3v76.4H212.9c-41 0-71.3 30.3-71.3 71.4 0 142.3.3 284.6-.2 426.9-.1 37.7 28.5 64.8 55 69.7 5.9 1.1 11.9 1.6 17.9 1.6 64.2.1 128.4.1 192.6.1h7.2v76c-.9.2-2 .6-3 .6-68.2 0-136.5.7-204.7-.3-66.7-1-125.7-51.6-138.5-117.1-1.8-9.2-2.7-18.8-2.7-28.2-.2-143.8-.5-287.7.1-431.5.3-60.1 30.1-103.2 82.2-131.2 18.4-9.9 38.7-14.4 59.6-14.4 67.7-.2 135.3-.1 203-.1 1.1 0 2.3.1 4.1.1zm0 0"/>'
  }
})
